module.exports = __webpack_public_path__ + "static/img/97.4ff55fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/97.png
// module id = xSyw
// module chunks = 0